import { AitCellData, newCell } from "aic";

/**
 * Preprocess cells ensuring aitid and columnId exist and default values are applied.
 *
 * @param defaultCellWidth - Default width to apply when colWidth is missing
 * @param blank - Blank value for generated cells
 * @param columnIds - Optional array of column IDs to assign
 * @param cs - Optional array of cells to process
 * @returns Array of processed cells
 */
export const cellPreProcess = <T>(
  defaultCellWidth: number,
  blank: T,
  columnIds: string[],
  cs?: AitCellData<T>[],
): AitCellData<T>[] => {
  if (cs === undefined) {
    if (!columnIds || columnIds.length === 0) {
      throw new Error("cellPreProcess: no column Id defined for the cell");
    }
    const columnId = columnIds[0];
    return [newCell(defaultCellWidth, blank, columnId)];
  }
  // Check aitid and columnId
  return cs.map((c, index) => {
    // Use provided columnId if available, otherwise use existing columnId, or generate new one
    const columnId = columnIds && columnIds.length > index ? columnIds[index] : c.columnId;
    return {
      aitid: c.aitid && c.aitid.length > 4 ? c.aitid : crypto.randomUUID(),
      text: c.text,
      justifyText: c.justifyText,
      comments: c.comments,
      colWidth: c.colWidth ?? defaultCellWidth,
      textIndents: c.textIndents,
      replacedText: undefined,
      spaceAfterRepeat: undefined,
      coreTrafficLight: c.coreTrafficLight,
      templateAitId: c.templateAitId,
      templateColumnAitId: c.templateColumnAitId,
      columnId,
    };
  });
};
